export enum GrantEnum {
    Task, // - dostęp do listy zadań
    PowerBi, // - dostęp do raportów
    ReportRanking, // - motywacja
    ReportScoreCard, // cele
    V360, // - widok 360
    Sharepoint, // informacje
    UserProfile, // - dostęp do administracji
    GlobalNotes, // - dostęp do notatek w głównej zakładce
    V360Notes, // - notatki/kontakty v360
    V360Employees, // - OFWCA w widoku 360
    V360SalesDataEhm, // - dane sprzedażowe dla EHM w widoku 360
    V360SalesDataEhz, // - dane sprzedażowe dla EHZ w widoku 360
    V360SalesDaily, // - sprzedaż dzienna
}
